<template>
    <div class="worklog-box">
        <div class="worklog-top white">
            <h3>{{infoData.workDate}}</h3>
            <div class="worker-box">
                <img class="worker-img" src="../../assets/img/user.png"/>
                <div class="worker-wrap">
                   <p class="name">{{infoData.uname}}</p>
                   <p class="time">{{time}}</p>
                </div>
            </div>
        </div>
        <ul class="information-box white">
            <li>
                <span>外界温度：</span>
                <span>{{infoData.workOutwarm}} ℃</span>
            </li>
            <li>
                <span>外界湿度：</span>
                <span>{{infoData.workOutwet}} %</span>
            </li>
            <li>
                <span>风力风向：</span>
                <span>{{infoData.workAir}} m/s</span>
            </li>
            <li>
                <span>目标温度：</span>
                <span>{{infoData.workWarm}} ℃</span>
            </li>
            <li>
                <span>舍内湿度：</span>
                <span>{{infoData.workWet}} %</span>
            </li>
            <li>
                <span>最小通风：</span>
                <span>{{infoData.workAirmi}}</span>
            </li>
            <li>
                <span>最大通风况：</span>
                <span>{{infoData.workAirmx}}</span>
            </li>
            <li>
                <span>二氧化碳浓度：</span>
                <span>上午{{infoData.workCo2a}} 下午{{infoData.workCo2p}} 夜间{{infoData.workCo2n}}</span>
            </li>
            <li>
                <span>工作回顾：</span>
                <span>{{infoData.workReview}}</span>
            </li>
            <li>
                <span>鸡群表现：</span>
                <span>{{infoData.workChickens}}</span>
            </li>
            <li>
                <span>工作总结：</span>
                <span>{{infoData.workSum}}</span>
            </li>
            <li>
                <span>免疫及用药记录：</span>
                <span>{{infoData.medicationRecord}}</span>
            </li>
        </ul>
        <div class="white bottomNone">
            <h3 class="title">明日工作计划</h3>
        </div>
        <ul class="tomorrow-plan white">
            <li>
                <span>外界温度：</span>
                <span>{{infoData.planOutwarm ? infoData.planOutwarm + ' ℃' : ''}}</span>
            </li>
            <li>
                <span>外界湿度：</span>
                <span>{{infoData.planOutwet ? infoData.planOutwet + ' %' : ''}}</span>
            </li>
            <li>
                <span>风力风向：</span>
                <span>{{infoData.planAir ? infoData.planAir + ' m/s' : ''}}</span>
            </li>
            <li>
                <span>目标温度：</span>
                <span>{{infoData.planWarm ? infoData.planWarm + ' ℃' : ''}}</span>
            </li>
            <li>
                <span>舍内温度：</span>
                <span>{{infoData.planWet ? infoData.planWet + ' %' : ''}}</span>
            </li>
            <li>
                <span>日龄：</span>
                <span>{{infoData.planAge}}</span>
            </li>
            <li>
                <span>负压：</span>
                <span>{{infoData.planPressure}}</span>
            </li>
            <li>
                <span>风机数量：</span>
                <span>{{infoData.planFan}}</span>
            </li>
            <li>
                <span>二氧化碳浓度：</span>
                <span>{{infoData.planCo2}}</span>
            </li>
            <li>
                <span>时控：</span>
                <span>{{infoData.planTimect}}</span>
            </li>
            <li>
                <span>温控：</span>
                <span>{{infoData.planWarmct}}</span>
            </li>
            <li>
                <span>饲养管理计划：</span>
                <span>{{infoData.planFeed}}</span>
            </li>
            <li>
                <span>加湿计划：</span>
                <span>{{infoData.planWetct}}</span>
            </li>
            <li>
                <span>人员管理计划：</span>
                <span>{{infoData.planPerson}}</span>
            </li>
            <li>
                <span>设备管理计划：</span>
                <span>{{infoData.planEquip}}</span>
            </li>
            <li>
                <span>其他管理计划：</span>
                <span>{{infoData.planOther}}</span>
            </li>
        </ul>
    </div>
</template>
<script>
import {workinfo} from '@/api/resetApi.js';
import { wxshare } from '@/utils/utils.js'
export default {
    data () {
        return {
            infoData:{},
            time:'',
        }
    },
    created(){
        document.title = '禽智养殖'
        if(this.$route.query.id){
            this.info()
        }
    },
    methods:{
        async info() {
            let res = await workinfo({ id: this.$route.query.id });
                if (res.data.code == 200) {
                   this.infoData = res.data.data
                   let h = new Date(Date.parse(res.data.data.createtime.replace(/-/g, '/'))).getHours()
                   let m = new Date(Date.parse(res.data.data.createtime.replace(/-/g, '/'))).getMinutes()
                   this.time = `${h>10?h:'0'+ h}:${m>10?m:'0'+ m}`
                   let title = '工作日志'
                   let desc = this.infoData.workDate + this.infoData.uname
                   wxshare('',title,desc,window.location.href);
                }
        },
    }
}
</script>
<style scoped lang="scss">
.worklog-box{
    background: #f8fbff;
}
.white{
    background: white;
}
.bottomNone{
    border-bottom: 1px solid #f5f5f5;
    padding: 0 3.73vw;
}
.title{
    font-size: 4.27vw;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 600;
    text-align: left;
    color: #127be4;
    line-height: 1;
    padding: 4.8vw 0;
}
.worklog-top{
    padding: 0 3.73vw 2.13vw;
    border-bottom: 1px solid #f5f5f5;
    border-top: 1px solid #f5f5f5;
    h3{
        font-size: 4.27vw;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: left;
        color: #333333;
        line-height: 1;
        padding: 4.8vw 0;
    }
    .worker-box{
        display: flex;
        align-items: center;
        .worker-img{
            width: 8.53vw;
            height: 8.53vw;
            border-radius: 50%;
            margin-right: 1.6vw;
        }
        .worker-wrap{
            flex: 1;
        }
        .name{
            font-size: 3.73vw;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            text-align: left;
            color: #181818;
            line-height: 5.33vw;
        }
        .time{
            font-size: 3.2vw;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #999999;
            line-height: 4.8vw;
        }
        .frequency{
            font-size: 3.73vw;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #999999;
            line-height: 4.8vw;
        }
    }
}
.information-box, .tomorrow-plan{
    padding: 2.57vw 3.73vw 0;
    margin-bottom: 3.2vw;
    li{
        font-size: 3.73vw;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: left;
        color: #717171;
        line-height: 1.5;
        padding: 1.87vw 0;
    }
}
.images-box{
    padding: 4.8vw 0;
    img{
        width: 100%;
    }
}
</style>